import React from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

import InputX from '../../form/InputX';
import InputSelect from '../../form/InputSelect';
// import Switch from '../svg/Switch';
import GroupButtons from '../../left-bar/GroupButtons';

function FormRoom({ hook }) {

  const {
    error,
    name, setName,
    genres, genre, setGenre,
    isPrivate,
    clickSwitch,
    //selectLimit, limit,
    clickButton,
    labelButton,
    cancelButton
  } = hook;

  return (
    <div className={`flexColumn cta create-room`}>
      <div className={`flexColumn modalV2 bottom-reduce`}>
        <div className={`flexColumn body`}>
          <div className={`title`}>B2B Settings</div>
          <div className={`flexColumn body-container`}>
            <div className={'flexColumn'} style={{gap: 0}}>
              <InputX containerClassName={`flexColumn container-inputV2`}
                labelClassName={`type-regular type-light label`}
                inputClassName={`inputV2 type-regular ${error && 'error'}`}
                name={`session_name`} label={``} placeholder={`Name your set`}
                value={name} type={`text`}
                modalHasEntered={null}
                setValueExternal={setName}
              />
              <InputSelect containerClassName={`flexColumn container-inputV2`}
                labelClassName={`type-regular type-light label`}
                selectClassName={`inputV2 input-select type-regular`}
                name={`session_genre`} label={``} placeholder={`Select a primary genre`}
                value={genre} setValueExternal={setGenre} options={genres}
              />
            </div>
            {/*
            <div className={`flexRow space-between`}>
              <span>Host a public session</span>
              <Switch className={'switch'} enable={!isPrivate} onClick={clickSwitch} />
            </div>
            */}
            <GroupButtons style={{margin: 0}}>
              <div className={`group-button type-medium fz15 ${ isPrivate && 'selected' }`} style={{padding: '14px 10px'}} onClick={clickSwitch}>Private Set</div>
              <div className={`group-button type-medium fz15 ${ !isPrivate && 'selected' }`} style={{padding: '14px 10px'}} onClick={clickSwitch}>Public Set</div>
            </GroupButtons>
            { /*
              <div className={`flexRow space-between`}>
                <span>Max number of DJs</span>
                <div className={'flexRow space-around number-select'}>
                  <span onClick={selectLimit(2)} className={`number ${limit === 2 && 'enable'}`}>2</span>
                  <span onClick={selectLimit(3)} className={`number ${limit === 3 && 'enable'}`}>3</span>
                  <span onClick={selectLimit(4)} className={`number ${limit === 4 && 'enable'}`}>4</span>
                </div>
              </div>
            */ }
          </div>
          <div className={`flexColumn group-cta`}>
            <div className={`cta ${ (name !== '') ? 'primary' : 'grey' }`} onClick={clickButton}>{labelButton}</div>
            <div className={`cta cancel`} onClick={cancelButton}>Cancel</div>
          </div>
        </div>
      </div>
    </div>
  )
}

FormRoom.propTypes = {
  hook: PropTypes.object.isRequired
}

export default FormRoom;
